/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DeploymentsCapabilitySpec { 
    /**
     * AWS account to use for binaries for creation and upgrade of deployment
     */
    account_type?: DeploymentsCapabilitySpec.AccountTypeEnum;
    /**
     * Allow Deployment Spec to specify any release in Available/Default for deployment
     */
    version_selection_allowed?: boolean;
    /**
     * Allow deployment deactivation to skip deleting resources in shadow account.
     */
    deactivation_without_cleanup_allowed?: boolean;
    /**
     * Allow import of deployments into service plane
     */
    import_allowed?: boolean;
    /**
     * Allow deployment reactivation.
     */
    srm_reactivation_allowed?: boolean;
    /**
     * Allow tenant to reconfigure IRR.
     */
    irr_reconfigure_allowed?: boolean;
    /**
     * List of all AWS regions supported for deployment
     */
    aws_regions_enabled?: string;
    /**
     * List of all EVS regions supported for deployment
     */
    evs_regions_enabled?: string;
    /**
     * Deactivation Mode
     */
    deactivation_mode?: DeploymentsCapabilitySpec.DeactivationModeEnum;
    /**
     * Allow parallel activation in org
     */
    num_parallel_deployments_allowed?: number;
    /**
     * Enable multiple SDDC providers for an org
     */
    multiple_sddc_providers_enabled?: boolean;
    /**
     * Enable SendGrid email service integration
     */
    sendgrid_enabled?: boolean;
    /**
     * List of all GCP regions supported for deployment
     */
    gcp_regions_enabled?: string;
    /**
     * Comma separated allowed deployment types for monitoring. Deployment types for monitoring are GCP, AWS.
     */
    asm_monitoring_enabled_providers?: string;
    /**
     * List of all cloud providers supported for deployment
     */
    supported_cloud_providers?: string;
    /**
     * List of all personas allowed for deployment
     */
    personas_allowed?: string;
    /**
     * Maximum number of on-premises deployments allowed
     */
    allowed_onprem_count?: number;
    /**
     * Whether SRM pairing is required for deployments
     */
    srm_pair_required?: boolean;
}
export namespace DeploymentsCapabilitySpec {
    export type AccountTypeEnum = 'RELEASE' | 'SHADOW';
    export const AccountTypeEnum = {
        RELEASE: 'RELEASE' as AccountTypeEnum,
        SHADOW: 'SHADOW' as AccountTypeEnum
    };
    export type DeactivationModeEnum = 'APPROVAL_REQUIRED' | 'APPROVAL_NOT_REQUIRED';
    export const DeactivationModeEnum = {
        APPROVAL_REQUIRED: 'APPROVAL_REQUIRED' as DeactivationModeEnum,
        APPROVAL_NOT_REQUIRED: 'APPROVAL_NOT_REQUIRED' as DeactivationModeEnum
    };
}


